import React, { useEffect, useState } from "react";
import { PageShell, PageHero, PageSection } from "../components/PageShell";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import AdminNav from "../components/AdminNav";
import { adminService } from "../services/adminService";
import { toast } from "sonner";

export default function AdminContactResponsesPage() {
  const [responses, setResponses] = useState([]);
  const [error, setError] = useState("");

  async function load() {
    setError("");
    const rRes = await adminService.listContactResponsesAdmin();
    if (!rRes.ok) return setError(rRes.error || "Failed to load contact responses");
    setResponses(rRes.data?.items || []);
  }

  useEffect(() => {
    load();
  }, []);

  return (
    <PageShell>
      <PageHero eyebrow="Admin" title="Contact" highlight="responses." description="Latest customer requests with contact status workflow." />
      <PageSection variant="content">
        <div className="mx-auto max-w-7xl grid gap-6">
          <AdminNav />
          {error ? <Card><CardContent className="py-4 text-sm text-destructive">{error}</CardContent></Card> : null}
          <div className="grid md:grid-cols-2 gap-4">
            {responses.map((r) => (
              <Card key={r._id} className="shadow-soft">
                <CardHeader>
                  <CardTitle className="flex items-center justify-between gap-3">
                    <span>{r.subject || "Message"}</span>
                    <span className={`text-xs rounded-full px-2 py-1 border ${
                      r.status === "resolved" ? "border-success text-success" : r.status === "contacted" ? "border-accent text-accent" : "border-destructive text-destructive"
                    }`}>
                      {r.status || "new"}
                    </span>
                  </CardTitle>
                </CardHeader>
                <CardContent className="grid gap-2 text-sm text-muted-foreground">
                  <div>{r.name || "-"} · {r.phone || "-"} · {r.email || "-"}</div>
                  <div className="whitespace-pre-wrap">{r.message}</div>
                  <div className="text-xs">Ack email: {r.ackEmailSent ? "sent" : "not sent"}</div>
                  <div className="flex gap-2 flex-wrap pt-1">
                    <Button size="sm" variant="outline" onClick={async () => { const rr = await adminService.updateContactResponse(r._id, { status: "contacted" }); if (!rr.ok) return toast.error(rr.error || "Update failed"); toast.success("Marked contacted"); await load(); }}>Mark contacted</Button>
                    <Button size="sm" variant="outline" onClick={async () => { const rr = await adminService.updateContactResponse(r._id, { status: "resolved" }); if (!rr.ok) return toast.error(rr.error || "Update failed"); toast.success("Marked resolved"); await load(); }}>Mark resolved</Button>
                    <Button size="sm" variant="outline" onClick={async () => { const rr = await adminService.deleteContactResponse(r._id); if (!rr.ok) return toast.error(rr.error || "Delete failed"); toast.success("Response deleted"); await load(); }}>Delete</Button>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
          {!responses.length ? <Card><CardContent className="py-6 text-sm text-muted-foreground">No contact form responses.</CardContent></Card> : null}
        </div>
      </PageSection>
    </PageShell>
  );
}

